module.exports = __webpack_public_path__ + "img/adhesive_residue_overlay.57b33694.jpeg";